import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import "../../src/styles/Noticias.css";
import { useNoticia } from "../hooks/useNoticia";
import { ListaNoticias } from "../components/ListaNoticias";
import { Titulo } from "../components/commons/Titulo";

export function Noticias() {
  const { getNoticiaByFechaCreacion } = useNoticia();
  const [listaNoticias, setListaNoticias] = useState(null);

  useEffect(() => {
    if (listaNoticias == null) {
      var obtenerNoticias = getNoticiaByFechaCreacion();
      obtenerNoticias.then(
        (promiseFullfilled) => {
          setListaNoticias(promiseFullfilled);
        },
        (promiseError) => {
          console.error("Error: " + promiseError);
        }
      );
    }
  }, []);

  return (
    <Container>
      <Titulo titulo={"Noticias"} size={"2.5em"}/>

      {listaNoticias &&
        listaNoticias.length > 0 && (
          <ListaNoticias cantidadNoticias={listaNoticias.length} justify={"center"} />
        )}
    </Container>
  );
}
